import * as React from 'react';
import { useParams } from 'react-router-dom';

import EmptyFollowUp from '@/pages/EmptyFollowUp';

const FollowUpIndex: React.FC = () => {
  const { followUpIndexId } = useParams();

  if (!followUpIndexId) {
    return <EmptyFollowUp />;
  }

  return null;
};

export default FollowUpIndex;
